<template>
  <div
    class="modal fade"
    id="viewSchedule"
    tabindex="-1"
    role="dialog"
    aria-labelledby="#viewScheduleLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-lgr"
      role="document"
    >
      <form
        class="modal-content"
        @submit="editTrainingCenterSchedule"
      >
        <div class="modal-header row">
          <div class="col col-sm-4">
            <h5
              class="modal-title font-weight-bold"
              id="viewScheduleLabel"
            >
              View Schedule
            </h5>
          </div>

          <div class="col col-sm-6 text-right">
            <a
              role="button"
              class="btn btn-sm btn-outline-danger font-weight-bolder ml-2 float-left"
              v-if="!trainingCenterScheduleEditable && trainingCenterSchedule.id"
              @click="removeTrainingCenterSchedule"
            >
              <span><i class="fas fa-ban" /></span>
              DELETE
            </a>

            <button
              type="submit"
              class="btn btn-sm btn-warning font-weight-bolder ml-2 float-right"
              v-if="trainingCenterSchedule.id"
            >
              <span><i class="fas fa-edit" /></span>
              {{ trainingCenterScheduleEditable ? 'UPDATE':'EDIT' }}
            </button>

            <a
              role="button"
              class="btn btn-sm btn-outline-secondary font-weight-bolder float-right"
              id="cancelButton"
              @click="trainingCenterScheduleEditable = false"
              v-if="trainingCenterScheduleEditable"
            >
              <span><i class="fas fa-ban" /></span>
              CANCEL
            </a>
          </div>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col col-sm-6">
              <div class="form-group form-row">
                <label
                  for="day"
                  class="col col-sm-4 col-form-label font-weight-bolder text-right"
                >Day of Week:</label>
                <div class="col col-sm-8">
                  <select
                    id="day"
                    class="form-control form-control-xs"
                    required
                    :disabled="!trainingCenterScheduleEditable"
                    v-model="trainingCenterSchedule.weekday_id"
                  >
                    <option
                      v-for="weekday in daysOfWeek"
                      :key="weekday.day"
                      :selected="weekday.day === trainingCenterSchedule.weekday_id"
                      :value="weekday.day"
                    >
                      {{ weekday.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  for="timeFrom"
                  class="col col-sm-4 col-form-label font-weight-bolder text-right"
                >Time From:</label>
                <div class="col col-sm-8">
                  <input
                    type="time"
                    id="timeFrom"
                    required
                    class="form-control form-control-xs"
                    :readonly="!trainingCenterScheduleEditable"
                    v-model="trainingCenterSchedule.time_from"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  for="timeTo"
                  class="col col-sm-4 col-form-label font-weight-bolder text-right"
                >Time To:</label>
                <div class="col col-sm-8">
                  <input
                    type="time"
                    id="timeTo"
                    required
                    class="form-control form-control-xs"
                    :readonly="!trainingCenterScheduleEditable"
                    v-model="trainingCenterSchedule.time_to"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  for="status"
                  class="col col-sm-4 col-form-label font-weight-bolder text-right"
                >Status:</label>
                <div class="col col-sm-1">
                  <input
                    type="checkbox"
                    id="status"
                    :disabled="!trainingCenterScheduleEditable"
                    class="form-control form-control-xs"
                    v-model="trainingCenterSchedule.status"
                  >
                </div>
                <label class="col-sm-4 col-form-label font-weight-bolder">
                  {{ trainingCenterSchedule.status ? 'ACTIVE':'INACTIVE' }}
                </label>
              </div>
            </div>

            <div class="col col-sm-6">
              <div class="form-group form-row">
                <label
                  for="createdBy"
                  class="col col-sm-4 col-form-label font-weight-bolder text-right"
                >Created By:</label>
                <div class="col col-sm-8">
                  <input
                    type="text"
                    id="createdBy"
                    readonly
                    class="form-control form-control-xs"
                    :value="trainingCenterSchedule.created_by | parseUser"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  for="createdAt"
                  class="col col-sm-4 col-form-label font-weight-bolder text-right"
                >Created At:</label>
                <div class="col col-sm-8">
                  <input
                    type="text"
                    id="createdAt"
                    readonly
                    class="form-control form-control-xs"
                    :value="trainingCenterSchedule.created_at | moment('D MMM YYYY hh:m A')"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  for="updatedBy"
                  class="col col-sm-4 col-form-label font-weight-bolder text-right"
                >Updated By:</label>
                <div class="col col-sm-8">
                  <input
                    type="text"
                    id="updatedBy"
                    readonly
                    class="form-control form-control-xs"
                    :value="trainingCenterSchedule.updated_by | parseUser"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  for="updatedAt"
                  class="col col-sm-4 col-form-label font-weight-bolder text-right"
                >Updated At:</label>
                <div class="col col-sm-8">
                  <input
                    type="text"
                    id="updatedAt"
                    readonly
                    class="form-control form-control-xs"
                    :value="trainingCenterSchedule.updated_at | moment('D MMM YYYY hh:m A')"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { formMixins } from "../../../../mixins/formMixins";

    export default {
        mixins: [formMixins],
        name: "ViewTrainingCenterSchedule",
        data() {
            return {
                trainingCenterScheduleEditable: false
            }
        },
        methods: {
            ...mapActions([ 'updateTrainingCenterSchedule', 'deleteTrainingCenterSchedule' ]),
            async editTrainingCenterSchedule(e) {
                e.preventDefault();
                if(this.trainingCenterScheduleEditable) {
                    if (await this.confirmUpdateAlert('Are you sure you want to update this schedule?')) {
                        if(await this.updateTrainingCenterSchedule()) {
                            this.successAlert('Training Center Schedule Successfully Updated', 'UPDATE');
                            this.trainingCenterScheduleEditable = false;
                        } else {
                            this.errorAlert(null, 'UPDATE RECORD');
                        }
                    }
                } else {
                    this.trainingCenterScheduleEditable = true;
                }
            },
            async removeTrainingCenterSchedule() {
                if(await this.deleteAlert('Are you sure you want to remove this schedule?')) {
                    if(await this.deleteTrainingCenterSchedule()) {
                        this.successAlert('Training Center Successfully Deleted!', 'DELETE');
                    } else {
                        this.errorAlert('Training Center Schedule Failed to Remove', 'DELETE');
                    }
                }
            }
        },
        computed: {
            ...mapGetters([ 'trainingCenterSchedule', 'daysOfWeek' ])
        }
    }
</script>

<style scoped>

</style>
